/* Landing DIGESTIVE: galeria, carrusel de opiniones y enlaces que abren acordeones. */
(function(){
  function each(sel,root,fn){Array.prototype.forEach.call((root||document).querySelectorAll(sel),fn)}
  function gal(root){
    if(root.getAttribute('data-dg-ok'))return;root.setAttribute('data-dg-ok','1');
    var sc=root.querySelector('.dg-gal-sc');if(!sc)return;
    var n=sc.children.length,num=root.querySelector('.dg-gal-n'),th=root.querySelectorAll('.dg-th button');
    function upd(){var i=Math.round(sc.scrollLeft/sc.clientWidth);if(i<0)i=0;if(i>n-1)i=n-1;if(num)num.textContent=(i+1)+'/'+n;for(var k=0;k<th.length;k++){th[k].classList.toggle('on',k===i)}}
    var t;sc.addEventListener('scroll',function(){clearTimeout(t);t=setTimeout(upd,60)},{passive:true});
    each('.dg-th button',root,function(b,k){b.addEventListener('click',function(){sc.scrollTo({left:sc.clientWidth*k,behavior:'smooth'})})});
    upd();
  }
  function car(root){
    if(root.getAttribute('data-dg-ok'))return;root.setAttribute('data-dg-ok','1');
    var sc=root.querySelector('.dg-rv-sc');if(!sc)return;
    var its=sc.children,dots=root.querySelectorAll('.dg-dot');
    function step(){return its.length>1?its[1].offsetLeft-its[0].offsetLeft:sc.clientWidth}
    function upd(){var i=Math.round(sc.scrollLeft/step());for(var k=0;k<dots.length;k++){dots[k].classList.toggle('on',k===i)}}
    var t;sc.addEventListener('scroll',function(){clearTimeout(t);t=setTimeout(upd,60)},{passive:true});
    each('.dg-dot',root,function(d,k){d.addEventListener('click',function(){sc.scrollTo({left:step()*k,behavior:'smooth'})})});
    upd();
  }
  function init(root){each('.dg-gal',root,gal);each('.dg-rv',root,car)}
  document.addEventListener('click',function(e){
    var a=e.target.closest?e.target.closest('[data-dg-open],[data-dg-ir]'):null;if(!a)return;
    var id=a.getAttribute('data-dg-open')||a.getAttribute('data-dg-ir');var el=document.getElementById(id);if(!el)return;
    e.preventDefault();if(el.tagName==='DETAILS'){el.open=true}
    el.scrollIntoView({behavior:'smooth',block:a.hasAttribute('data-dg-open')?'center':'start'});
  });
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){init()})}else{init()}
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();